import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {FormCardSection} from '@/components/ui/form-atoms/FormAtoms'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {Text} from '@/components/ui/text/Text'
import {PlannedAccessesAbsenceTotalDetails} from '@/features/planned-accesses/components/planned-accesses-absence-total-details/PlannedAccessesAbsenceTotalDetails'
import {useAbsenceThreshold} from '@/features/planned-accesses/hooks/useAbsenceThreshold'
import {AssistiveRegimeEnum} from '@/features/projects/types'
import {useTranslation} from '@/translations/i18n'
import {PatientAgeRange} from '@/types'

interface PlannedAccessesTotalAbsencesCardProps {
    isLoading: boolean
    assistiveRegime: AssistiveRegimeEnum | null
    serviceType: Exclude<PatientAgeRange, 'evolutionary_age_adults'> | null
    totalInPresenceAccessesCount: number
    totalAbsencesAccessesCount: number
}

export const PlannedAccessesTotalAbsencesCard = ({
    isLoading,
    assistiveRegime,
    totalAbsencesAccessesCount,
    totalInPresenceAccessesCount,
    serviceType
}: PlannedAccessesTotalAbsencesCardProps) => {
    const {t} = useTranslation()
    const {selectedAbsenceThresholdPercentage} = useAbsenceThreshold({
        assistiveRegime,
        serviceType,
        totalInPresenceAccessesCount
    })

    if (isLoading) {
        return (
            <FormCardSection columns={2} padding={3}>
                <DetailsField>
                    <Text size="textSm" weight="400" palette="neutral" shade="600">
                        {t('planned_accesses:total_absences_field_title')}
                    </Text>
                    <Text size="textSm" weight="500">
                        <Skeleton width="100%" height="24px" />
                    </Text>
                </DetailsField>
                <DetailsField>
                    <Text size="textSm" weight="400" palette="neutral" shade="600">
                        {t('planned_accesses:absence_threshold_field_title')}
                    </Text>
                    <Text size="textSm" weight="500">
                        <Skeleton width="100%" height="24px" />
                    </Text>
                </DetailsField>
            </FormCardSection>
        )
    }

    return (
        <FormCardSection columns={1} padding={3}>
            <PlannedAccessesAbsenceTotalDetails
                totalAbsencesAccessesCount={totalAbsencesAccessesCount}
                totalInPresenceAccessesCount={totalInPresenceAccessesCount}
                selectedAbsenceThresholdPercentage={selectedAbsenceThresholdPercentage}
            />
        </FormCardSection>
    )
}
